import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  DrugReferenceFgNdcPayload,
  DrugReferenceFgNdcResponse,
  DrugReferenceFgNdcSingleResponse
} from 'Interfaces/ReferenceInterfaces/DrugReferenceFgNdcInterface';

export const drugReferenceFgNdcServices = {
  getAllDrugReferenceFgNdcs: (
    page = 1,
    pageSize = 10000,
    search?: string
  ): Promise<DrugReferenceFgNdcResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = `pps/drug-reference-fg-ndcs?page=${page}&page_size=${pageSize}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }

        const { data } = await getRequest<DrugReferenceFgNdcResponse>(url);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getDrugReferenceFgNdcById: (id: number): Promise<DrugReferenceFgNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<DrugReferenceFgNdcSingleResponse>(
          `pps/drug-reference-fg-ndcs/${id}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createDrugReferenceFgNdc: (
    drugReferenceData: DrugReferenceFgNdcPayload
  ): Promise<DrugReferenceFgNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<DrugReferenceFgNdcSingleResponse>(
          'pps/drug-reference-fg-ndcs/',
          drugReferenceData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateDrugReferenceFgNdc: (
    id: number,
    drugReferenceData: DrugReferenceFgNdcPayload
  ): Promise<DrugReferenceFgNdcSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<DrugReferenceFgNdcSingleResponse>(
          `pps/drug-reference-fg-ndcs/${id}/`,
          drugReferenceData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteDrugReferenceFgNdc: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/drug-reference-fg-ndcs/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
